import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Header from './components/Header';
import Footer from './components/Footer';
import Terms from './pages/Terms';
import Policy from './pages/Policy';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';  // Import the NotFound page
import CourseDetailPage from './pages/CourseDetailPage';


const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (!hash) return;

    const id = hash.replace('#', '');
    if (!id) return;

    const attemptScroll = () => {
      const el = document.getElementById(id);
      if (!el) return false;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    };

    if (attemptScroll()) return;
    const t = window.setTimeout(() => {
      attemptScroll();
    }, 50);

    return () => window.clearTimeout(t);
  }, [location.hash, location.pathname]);

  return null;
};


const App = () => {
 return (
   <Router>
     <ScrollToHash />
     <Header />
     <Routes>
       <Route path="/" element={<HomePage />} />
       <Route path="/terms-of-service" element={<Terms />} />
       <Route path="/privacy-policy" element={<Policy />} />
       <Route path="/contact" element={<Contact />} />
       <Route path="/courses/:courseId" element={<CourseDetailPage />} />


       {/* Catch-all route for 404 pages */}
       <Route path="*" element={<NotFound />} />
     </Routes>
     <Footer />
   </Router>
 );
};


export default App;


